"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ui_1 = require("@rahtab/ui");
const native_1 = require("@react-navigation/native");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const ArrowLeftIcon_1 = __importDefault(require("@rahtab/ui/dist/icons/ArrowLeftIcon"));
const HeaderTitle = ({ title }) => {
    const { canGoBack, goBack } = native_1.useNavigation();
    const BackButton = react_1.useMemo(() => {
        if (!canGoBack() || !ui_1.isStandalone())
            return () => null;
        return () => (react_1.default.createElement(react_native_1.TouchableOpacity, { style: styles.back, onPress: goBack },
            react_1.default.createElement(ArrowLeftIcon_1.default, { style: styles.arrowLeftIcon })));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (react_1.default.createElement(react_native_1.View, { style: styles.headerTitleContainer },
        react_1.default.createElement(ui_1.Text, { margin: "none", variant: "title" }, title),
        react_1.default.createElement(BackButton, null)));
};
exports.default = HeaderTitle;
const styles = react_native_1.StyleSheet.create({
    headerTitleContainer: {
        alignItems: 'center',
        height: 24,
        justifyContent: 'center',
    },
    back: {
        start: 0,
        position: 'absolute',
        padding: ui_1.getSpacing(0.333),
        transform: [{ rotate: '180deg' }],
    },
    arrowLeftIcon: {
        height: ui_1.getSpacing(1.4),
        width: ui_1.getSpacing(1.608),
    },
});
